import { HeaderContentDirective } from './content.directive';
import { HeaderLogoDirective } from './logo.directive';
import { HeaderMenuItemDirective } from './menu-item.directive';

export const Directives = [
	HeaderContentDirective,
	HeaderLogoDirective,
	HeaderMenuItemDirective,
];
